module.exports = __webpack_public_path__ + "img/highlighted_nodes_by_metrics-drawer.5087c49a.png";